module.exports = __webpack_public_path__ + "img/logo.50dc1919.jpg";